import { IBooking, PassengerPriceDetails } from "../../../Orchestrator/Types/Index";

export class CancelBookingContext {
    public routeTo: string[] = []
    public allFulFillOutBoundPassIds: string[] = [];
    public outBoundPassengerPriceList: PassengerPriceDetails[] = [];
    public purchaserEmail: string = "";
    public booking!: IBooking;

    constructor() {
        // Initialize properties
    }
} 